<template>
  <div class="item">
    <div class="item-body">
      <div
        v-if="!mode || mode !== 'view'"
        class="delete-cart" 
        @click="deleteCart()">
        <i class="fa fa-times" />
      </div>
      <div class="item-left">
        <img
          :src="base_url + vatpham.image"
          width="100%"
          alt=""
          @error="replaceByDefault">
      </div>
      <div class="item-right">
        <div class="item-info">
          <div class="name-item">{{ vatpham.name }}</div>
          <div class="price">
            <b class="sale-price">{{ vatpham.price_sale }} đ</b>&ensp;
            <span 
              v-if="vatpham.price && !mode || mode !== 'view'" 
              class="original-price">{{ vatpham.price }} đ</span>
            <b v-if="mode && mode === 'view'">x {{ vatpham.count }}</b>
          </div>
          <div 
            v-if="!mode || mode !== 'view'" 
            class="qty_item_click">
            <div
              class="sub"
              @click="decrease()"><a href="#">-</a></div>
            <div class="qty">{{ vatpham.count }}</div>
            <div
              class="add"
              @click="increase()"><a href="#">+</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ApiConfig from "../../communicate/ApiConfig";
  import defaultImage from '../../assets/images/default.png';

  export default {
    name: "CardItem",
    props: ['vatpham', 'mode'],
    data() {
      return {
        base_url: ApiConfig.base_url
      }
    },
    methods: {
      increase() {
        this.vatpham.count++;
        this.$emit('updateCount', this.vatpham);
      },
      decrease() {
        if (this.vatpham.count > 1) {
          this.vatpham.count--;
          this.$emit('updateCount', this.vatpham);
        }
      },
      replaceByDefault(e) {
        e.target.src = defaultImage;
      },
      deleteCart() {
        this.$emit('deleteCart', this.vatpham);
      }
    }
  }
</script>

<style scoped>
  .item {
    padding: 8px;
    width: 100%;
  }

  .delete-cart {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 12px;
    cursor: pointer;
  }

  .item-body {
    position: relative;
  }

  .item .item-body .item-right {
    display: table;
  }
  .item .item-body .item-right .item-info {
    padding: 8px;
    display: table-cell;
    vertical-align: middle;
  }
  .item .item-body .item-right .item-info .name-item {
    font-size: 0.9rem;
    font-weight: bold;
  }
  .item .item-body .item-right .item-info .sale-price {
    color: #FF595A;
    font-size: 14px;
    margin-top: 5px;
  }
  .item .item-body .item-right .item-info .original-price {
    color: gray;
    font-size: 13px;
    margin-top: 5px;
    margin-left: 3px;
    text-decoration: line-through;
  }
  .qty_item_click {
    margin-top: 5px;
    border: 1px solid #e2e2e2;
    display: -webkit-flex; /* Safari */
    display: flex;
    width: 60%;
  }

  .qty_item_click div {
    -webkit-flex: 1; /* Safari 6.1+ */
    -ms-flex: 1; /* IE 10 */
    flex: 1;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
  }

  .sub, .add {
    background-color: #e2e2e2;
  }
</style>



// WEBPACK FOOTER //
// src/components/cart/CardItem.vue